import {SET_APPLY, setApplyT} from "../reducers/ApplyState";


export const SetApply = (data: setApplyT['data']) => {
    return({
        type: SET_APPLY,
        data: data
    })
}
